module.exports = __webpack_public_path__ + "static/twin-1cd5349cfb0ef312a7204ae00fa51b6b.png";